export const detectBudgetRevenueIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /* ----------------------------------
     * DELETE budget revenue
     * ---------------------------------- */
    const deleteRegex =
        /(delete|remove|erase|drop|get rid of)\s+(the\s+)?(budget revenue)?\s*(named|called|for)?\s*(.+)?/;

    const deleteMatch = cleaned.match(deleteRegex);

    if (
        deleteMatch &&
        cleaned.includes("budget") &&
        cleaned.includes("revenue")
    ) {
        return {
            intent: "delete_budget_revenue",
            name: deleteMatch[5]?.trim() || undefined
        };
    }

    /* ----------------------------------
     * CREATE budget revenue
     * ---------------------------------- */
    const createRegex =
        /(create|add|make|setup|set up|configure|define)\s+(a\s+|new\s+)?(budget revenue)?\s*(named|called|for)?\s*(.+)?/;

    const createMatch = cleaned.match(createRegex);

    if (
        createMatch &&
        cleaned.includes("budget") &&
        cleaned.includes("revenue")
    ) {
        return {
            intent: "create_budget_revenue",
            name: createMatch[5]?.trim() || undefined
        };
    }

    return null;
};
